/* Both columns follow page scrolling, then pin at their bottom until the product row ends. */
(() => {
  if (window.monateoProductColumnsLoaded) return;
  window.monateoProductColumnsLoaded = true;
  const observers = new Map();
  const reviewObservers = new Map();
  function hideReviewCount(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const nodes = []; let node; let text = '';
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script, style, .areviewstooltiptext, .areviews_tooltip_portal')) continue;
      nodes.push({ node, start: text.length }); text += node.data;
    }
    const hideCount = container.hasAttribute('data-hide-review-count');
    const ranges = [...text.matchAll(/(\(\s*[\d.,\s]+)\s*(?:reviews?|avis)\s*\)/gi)].map(match =>
      hideCount
        ? [match.index, match.index + match[0].length]
        : [match.index + match[1].trimEnd().length, match.index + match[0].length - 1]
    );
    if (!ranges.length) return;
    nodes.forEach(({ node, start }) => {
      const original = node.data;
      let value = original;
      ranges.slice().reverse().forEach(([from, to]) => {
        const a = Math.max(0, from - start), b = Math.min(original.length, to - start);
        if (b > a) value = value.slice(0, a) + value.slice(b);
      });
      if (value !== original) node.data = value;
    });
  }
  function setup(root = document) {
    root.querySelectorAll('.areviews_header_stars').forEach(container => {
      if (reviewObservers.has(container)) return;
      const observer = new MutationObserver(() => hideReviewCount(container));
      observer.observe(container, { childList: true, characterData: true, subtree: true });
      reviewObservers.set(container, observer);
      hideReviewCount(container);
    });
    root.querySelectorAll('.monateo-independent-columns').forEach(product => {
      if (observers.has(product)) return;
      const columns = [...product.children].filter(node => node.matches('.product__media-wrapper, .product__info-wrapper'));
      const update = () => {
        columns.forEach(column => {
          column.removeAttribute('tabindex');
          const clearance = parseFloat(getComputedStyle(product).getPropertyValue('--product-scroll-offset')) || 0;
          // A tall column scrolls with the document until its bottom reaches the viewport.
          // Sticky positioning then holds it within the shared product row's boundaries.
          const top = Math.min(0, window.innerHeight - column.getBoundingClientRect().height - clearance);
          column.style.setProperty('--column-sticky-top', `${top}px`);
        });
      };
      const observer = new ResizeObserver(update);
      columns.forEach(column => observer.observe(column));
      window.addEventListener('resize', update);
      observers.set(product, { observer, update });
      update();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    reviewObservers.forEach((observer, container) => {
      if (event.target.contains(container)) { observer.disconnect(); reviewObservers.delete(container); }
    });
    observers.forEach(({ observer, update }, product) => {
      if (!event.target.contains(product)) return;
      observer.disconnect();
      window.removeEventListener('resize', update);
      observers.delete(product);
    });
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-guide-accordion] > summary, [data-product-guide-open]');
    if (!trigger) return;
    const section = trigger.closest('.shopify-section') || trigger.closest('[id^="shopify-section-"]');
    const picker = section?.querySelector('monateo-size-picker');
    if (!picker?.querySelector('[data-size-guide-modal]')) return;
    event.preventDefault();
    picker.open(trigger, event.detail === 0);
  });
})();
